<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        Você está excluindo a conta
        <b>
          {{ data.account_nickname }}
        </b>
      </div>
      <div class="col-md-12">
        <label>O que deseja fazer?</label>
        <div>
          <div v-if="false" class="form-check form-check-inline">
            <input
              v-model="type"
              class="form-check-input"
              type="radio"
              name="type"
              id="DELETE"
              value="DELETE"
            />
            <label class="form-check-label" for="DELETE"
              >Excluir todos os lançamentos desta conta</label
            >
          </div>
          <div class="form-check form-check-inline">
            <input
              v-model="type"
              class="form-check-input"
              type="radio"
              name="type"
              id="TRANSFER"
              value="TRANSFER"
            />
            <label class="form-check-label" for="TRANSFER"
              >Transferir lançamentos para outra conta</label
            >
          </div>
        </div>
      </div>
      <div v-if="type == 'TRANSFER'" class="col-md-12">
        <label>Migrar para</label>
        <select v-model="account_id" class="form-control">
          <option value="">SELECIONE...</option>
          <option
            v-for="(account, key) in accounts"
            :value="account.id"
            :key="key"
            v-show="account.id != data.id"
          >
            {{ account.account_nickname }}
          </option>
        </select>
      </div>
      <div class="col-md-12 pt-0 pb-0"><ErrorsMessages :errors="errors" /></div>
      <div class="col-md-6">
        <v-btn @click="$emit('cancel')" class="btn-cancel">
          <i class="fas fa-times mr-2 text-twenty"></i>
          CANCELAR
        </v-btn>
      </div>
      <div class="col-md-6 text-right">
        <v-btn :disabled="loading" @click="handleDelete" class="btn-delete">
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "EXCLUIR" }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

export default {
  name: "Delete",
  props: {
    data: Object,
    accounts: Array,
  },
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      type: "TRANSFER",
      account_id: "",
      loading: false,
      errors: [],
    };
  },
  methods: {
    async handleDelete() {
      try {
        this.loading = true;

        const {
          data: { id },
          type,
          account_id,
        } = this;

        let data = { id, type, account_id };

        const response = await api.delete(
          "/rest-home/financial/configuration/account",
          { data }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$bvModal.hide(`edit-account-${data.id}`);

          this.$emit("success");

          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

